import { CardImage } from "../card_image.js";

export function CardImagePizza(props) {
  let value = props.data;
  return (
    <CardImage id={value.id} key={value.id} title={value.Nom} src={value.Photo}>
      <p>{value.Ingredients}</p>
      <div className="content_footer">
        {value.Prix_Petite && (
          <>
            <div className="content">
              {"Petite : " + value.Prix_Petite + " €"}
            </div>
            <div className="content">
              {"Grande : " + value.Prix_Grande + " €"}
            </div>
          </>
        )}
        {<div className="content">{"Prix : " + value.Prix_Grande + " €"}</div>}
      </div>
    </CardImage>
  );
}
